var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{class:_vm.classes,style:(_vm.customStyle),attrs:{"dark":!_vm.disabled,"loading":_vm.loading,"text":!_vm.isPrimary,"disabled":_vm.disabled,"color":_vm.color,"small":""},on:{"click":_vm.click}},[_vm._v(" "+_vm._s(_vm.$t(_vm.text))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }